import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import axios from 'axios';

import {
    checkIFSC,
    d2cOfflinePayment,
    getProposalDetails,
    deletePaymentMethod,
    approvePayment,
    } from "../../store/actions/paymentActions";
    import MobilePopUp from "../MobilePopUp/MobilePopUp";
    import Calendar from "../Calendar/Calendar";
    import {
    getUserDetails,
    indianCurrencyFormat,
    pastDate,
    toaster,
    formateDateManually,
    formateENGBManually
    } from "../../utils/utils";
    import { branchLocation } from "../../constans/branchLocation";
    import deleteButton from "../../Assets/images/delete_small_icon.svg";
import Input2 from "../Input/Input2";
import apiConstants from '../../constans/apiConstants';

window.envType = localStorage.getItem('envType') ? localStorage.getItem('envType') : 'DEV';
const PaymentOptions = (props) => {
    const initialState = {
        accountNo: "",
        bankName: "",
        checkOrDdNumber: "",
        chequeOrDdDate: "",
        customerId: "",
        depositDate: "",
        depositSlipNumber: "",
        expiryDate: "",
        ifscCode: "",
        interactionId: "",
        link: "",
        nreAccount: "NO",
        oldPolicyNumber: "",
        payAtBankName: "",
        paymentAmount: "",
        paymentMethod: "DEMAND_DRAFT",
        paymentStatus: true,
        proposalNumber: props.proposalNumber,
        sendLinkOnEmail: true,
        txDate: "",
        txnRefNumber: "",
        utrNumber: "",
        branchCd: "",
        paymentId: null,
        hour:"",
        min:"",
        sec:""
    };

    const [payment, setPayment] = useState(initialState);
    const [showdate, openDate] = useState(false);
    const [payEnable, setPayEnable] = useState(true);
    const [branch, setBranch] = useState(payment.branchCd);
    const [ifscError, setIfscError] = useState("");
    const [editAmountChecker, setAmountChecker] = useState(false);
    const [enableNeftpayment, setEnableNeftpayment] = useState(false);
    const [enableCashPayment, setEnableCashPayment] = useState(false);

    const [paymentChecker, setPaymentChecker] = useState(false);
    const [AmtVal, setAmtVal] = useState("");
    const[time, setTime]=useState({
        hour:payment.hour,
        min:payment.min,
        sec:payment.sec
      });
    const dispatch = useDispatch();
    const { proposalDetails, ifsc, eligibilty, paymentd2c } = useSelector(
        (state) => ({
        proposalDetails: state.paymentReducer.proposalDetails,
        ifsc: state.paymentReducer.ifsc,
        eligibilty: state.paymentReducer.eligibilty,
        paymentd2c: state.paymentReducer.paymentd2c,
        })
    );

    useEffect(() => {
        if (!editAmountChecker) {
        setPayment((prevState) => ({
            ...prevState,
            paymentAmount: getRemainingPremium(true),
        }));
        }
    }, [proposalDetails, payment.paymentMethod]);

    useEffect(() => {
        if(proposalDetails?.channelInfo) {
            const { channelInfo: { subChannelName = '', channelName = '', sourceName = '', cabPartnerName = '' } = {} } = proposalDetails;
            const query = `partnerName=${cabPartnerName}&subChannel=${subChannelName}&channel=${channelName}&sources=${sourceName}`;
            axios.get(`${apiConstants().PROPOSEL_API_URL}api/v1/proposal/instaVerify/neftRequired?${query}
            `, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": localStorage.getItem('token'),
                }
            }).then((res) => {
                setEnableNeftpayment(res?.data?.body);
            }).catch((err) => {
                if (err && err.data) {
                    toaster('error', err.data.message)
                }
            })
            axios.get(`${apiConstants().PROPOSEL_API_URL}api/v1/proposal/instaVerify/cashRequired?${query}
            `, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": localStorage.getItem('token'),
                }
            }).then((res) => {
                setEnableCashPayment(res?.data?.body);
            }).catch((err) => {
                if (err && err.data) {
                    toaster('error', err.data.message)
                }
            })
        }
    }, [proposalDetails]);

    const totalPremium = proposalDetails?.paymentDetails?.totalPremiumPayable
        ? proposalDetails?.paymentDetails?.totalPremiumPayable
        : 0;

    const channelName = proposalDetails?.channelInfo?.channelName;

    const paymentChangeHandler = (name, value) => {
        let getdata = { ...payment };
        const letters= /^[0-9]*$/
        if(name==='hour'){ 
        if( (letters.test(value) || value==="")&& ( value<24)){
            setTime({
            ...time,
            [name]: value
        });
             getdata[name]= value
            }
    }
    else if(name==="min"){
        if( (letters.test(value) || value==="")&& ( value<=59)){
        setTime({
            ...time,
            [name]: value
        });
        getdata[name]= value
    }
    }else if(name==="sec"){
        if( (letters.test(value) || value==="")&& ( value<=59)){
        setTime({
            ...time,
            [name]: value
        });
        getdata[name]= value
    }
    }
        if (
        localStorage?.getItem('envType') === "DEV" &&
        !editAmountChecker &&
        Number(value) > Number(getPayLimit()) &&
        name === "paymentAmount"
        ) {
        return;
        }
        if (
            localStorage?.getItem('envType') !== "DEV" &&
            !editAmountChecker &&
            Number(value) > Number(getRemainingPremium(true)) &&
            name === "paymentAmount"
            ) {
            return;
            }
        if (name === "chequeOrDdDate") {
        getdata[name] = formatDate(new Date(value));
        getdata["expiryDate"] = formatDate(addDays(value, 90));
        } else if (name === "paymentMethod") {
        if (editAmountChecker) {
            getdata["paymentAmount"] = AmtVal;
        } else getdata = { ...initialState };
        getdata[name] = value;
        } else {
        if (editAmountChecker) {
            if (
            Number(value) > Number(AmtVal) + Number(getRemainingPremium()) &&
            name === "paymentAmount"
            ) {
            return;
            }
            getdata[name] = value;
        } else getdata[name] = value;
        }
        if (name === "ifscCode" && value) {
        if (value.length > 11) {
            return;
        } else {
            if (value.length === 11) {
            if (/([A-Z]){4}0([A-Z0-9]){6}$/.test(value.toUpperCase())) {
                dispatch(checkIFSC(value.toUpperCase()));
                setIfscError("");
            } else {
                getdata["bankName"] = "";
                setIfscError("Incorrect IFSC format.");
            }
            } else if (value.length === 0) {
            setIfscError("");
            }
        }
        }
        setPayment(getdata);
    };

    const locationChange = (item) => {
        const getdata = { ...payment };
        getdata["branchCd"] = item ? item.key : initialState.branchCd;
        setBranch(item);
        setPayment(getdata);
    };

    const padTo2Digits = (num) => {
        return num.toString().padStart(2, "0");
    };
    const formatDate = (date) => {
        return [
        padTo2Digits(date.getDate()),
        padTo2Digits(date.getMonth() + 1),
        date.getFullYear(),
        ].join("-");
    };
    const addDays = (date, days) => {
        var result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    };
    const calendarFunction = () => {
        openDate(true);
    };

    const payNow = () => {
        if (payment.paymentMethod === "CASH") {
        payment.bankName = "";
        }
        if (window?.envType === "DEV" && (payment.paymentMethod === "CHEQUE" || payment.paymentMethod === "DEMAND_DRAFT")) {
            payment.txDate = formateENGBManually(new Date(), null, true);
            }
        if(payment.paymentMethod === "NEFT"){
            // payment['txDate']= `${payment.chequeOrDdDate} ${time.hour}:${time.min}:${time.sec}`;
            payment['txDate']= window?.envType === "DEV" ? formateDateManually(payment.chequeOrDdDate) : `${payment.chequeOrDdDate} ${time.hour}:${time.min}:${time.sec} `;
            payment['txnRefNumber']= payment['utrNumber'];
        }
        dispatch(d2cOfflinePayment(payment,()=>{props.search()}));
        setPayment(initialState);
        setBranch(initialState.branchCd);
        setPaymentChecker(false);
        setPaymentChecker(false);
        setTime({
            hour:"",
            min:"",
            sec:""
        })
    };

    const getTotalPaid = () => {
        let totalPaid = 0;
        if (
        proposalDetails.paymentDetails.methodsOfPayments &&
        proposalDetails.paymentDetails.methodsOfPayments.length
        ) {
        proposalDetails.paymentDetails.methodsOfPayments.forEach(
            (item, index) => {
            if (item.txAmount) {
                totalPaid = totalPaid + item.txAmount;
            }
            }
        );
        return totalPaid;
        } else {
        return 0;
        }
    };

    const getRemainingPremium = (forInput = false) => {
        let totalPaid = 0;
        if (
        proposalDetails?.paymentDetails?.methodsOfPayments &&
        proposalDetails.paymentDetails.methodsOfPayments.length
        ) {
        proposalDetails.paymentDetails.methodsOfPayments.forEach(
            (item, index) => {
            if (item.txAmount) {
                totalPaid = totalPaid + item.txAmount;
            }
            }
        );
        if (
            forInput &&
            payment.paymentMethod === "CASH" &&
            totalPremium - totalPaid > 199999
        ) {
            return "199999";
        }
        return totalPremium - totalPaid;
        } else {
        if (
            forInput &&
            payment.paymentMethod === "CASH" &&
            totalPremium > 199999
        ) {
            return "199999";
        }
        return totalPremium;
        }
    };

    const getPayLimit = () => {
        if(proposalDetails.issuanceType === "NEWGEN"){
            return (
                Math.floor(getRemainingPremium()) +
                (Math.floor(totalPremium) * 30) / 100
              );
        }else{
            return (
                Math.floor(getRemainingPremium()) +
                (Math.floor(totalPremium) * 20) / 100
              );
        }
       
      };

    useEffect(() => {
        if (payment.paymentMethod === "CASH") {
            if (
                payment.paymentAmount !== "" &&
                Number(payment.paymentAmount) > 0 &&
                payment.branchCd !== ""
            ) {
                setPayEnable(false);
            } else {
                setPayEnable(true);
            }
        }
        if (payment.paymentMethod === "CHEQUE") {
            if (
                payment.paymentAmount !== "" &&
                Number(payment.paymentAmount) !== 0 &&
                payment.ifscCode !== "" &&
                payment.bankName !== "" &&
                payment.chequeOrDdDate !== "" &&
                payment.expiryDate !== "" &&
                payment.checkOrDdNumber?.length === 6 &&
                payment.branchCd !== ""
            ) {
                setPayEnable(false);
            } else {
                setPayEnable(true);
            }
        }
        if (payment.paymentMethod === "DEMAND_DRAFT") {
            if (
                payment.paymentAmount !== "" &&
                Number(payment.paymentAmount) !== 0 &&
                payment.bankName !== "" &&
                payment.chequeOrDdDate !== "" &&
                payment.expiryDate !== "" &&
                payment.checkOrDdNumber !== "" &&
                payment.branchCd !== ""
            ) {
                setPayEnable(false);
            } else {
                setPayEnable(true);
            }
        }

        if (payment.paymentMethod === "NEFT") {
            if (window.envType === "DEV" ?
                payment.paymentAmount !== "" &&
                Number(payment.paymentAmount) !== 0 &&
                payment.chequeOrDdDate !== "" &&
                payment.utrNumber !== "" &&
                payment.branchCd !== "" 
                // payment.hour !== "" &&
                // payment.min !== "" &&
                // payment.sec !== ""
                :
                payment.paymentAmount !== "" &&
                Number(payment.paymentAmount) !== 0 &&
                payment.chequeOrDdDate !== "" &&
                payment.utrNumber !== "" &&
                payment.branchCd !== "" &&
                payment.hour !== "" &&
                payment.min !== "" &&
                payment.sec !== ""      
            ) {
                setPayEnable(false);
            } else {
                setPayEnable(true);
            }
        }
    }, [payment]);

    useEffect(() => {
        const getdata = { ...payment };
        if (ifsc) {
        getdata.bankName = ifsc.bank;
        setPayment(getdata);
        }
    }, [ifsc]);

    const deletePayMethod = (id) => {
        dispatch(deletePaymentMethod(props.proposalNumber, id,  ()=>{
            props.search()}));
    };

    const onApprove = (id, proposalNumber) => {
        dispatch(approvePayment(
            {
            id,
            proposalNumber,
            },
            () => {
            dispatch(getProposalDetails(proposalNumber));
            props.search();
            }
        )
        );
    };

    const editPaymentChecker = (item) => {
        setPaymentChecker(true);
        const getData = { ...payment };
        if(item.paymentMethod === "DEMAND_DRAFT" || item.paymentMethod === "CHEQUE") {
            getData.checkOrDdNumber = item.chequeDdNo;
            getData.chequeOrDdDate = item.chequeOrDdDate;
            getData.expiryDate = item.expiryDate;
            getData.bankName = item.bankName
        }

        if (item.paymentMethod === "CHEQUE") {
            getData.ifscCode =  item.ifscCode;
        }
        getData.paymentAmount = item.txAmount;
        getData.paymentId = item.id;
        getData.branchCd = item.branchCd;
        getData.paymentMethod = item.paymentMethod;

        const selectedBranch = branchLocation.filter((branch) => {
        return branch.key === item.branchCd;
        });
        setAmountChecker(true);
        setAmtVal(item.txAmount);
        setBranch(selectedBranch);
        setPayment(getData);
    };
    const checkZeroForTime=(value,name)=>{
        if(value.length === 1){
          setTime({
            ...time,
            [name]:"0"+[value],
        });
      }
    }
    return (
        <>
        {proposalDetails?.paymentDetails?.methodsOfPayments && (
            <div>
            <div className="payable-wrapper">
                <div className="payable-heading">Total Premium</div>
                <div className="payable-amount">
                ₹ {indianCurrencyFormat(totalPremium)}
                <br />
                </div>
            </div>
            <div className="payable-wrapper">
                <div>
                <div className="payable-heading">Total Premium Paid</div>
                <div className="payable-amount">
                    ₹ {indianCurrencyFormat(getTotalPaid())}
                    <br />
                </div>
                </div>
                {proposalDetails?.paymentDetails?.methodsOfPayments.map(
                (item, index) => {
                    return (
                    <div key={index} className="payment-methods">
                        <div className="payment-methods-item">
                        {item.paymentMethod}:
                        </div>
                        <div className="payment-methods-value">
                        {(item.paymentMethod === "ONLINE_BILL_DESK" ||
                            item.paymentMethod === "ONLINE_LINK") ? <div></div> : getUserDetails().user.role === "CHECKER" ? (
                            <div className="py-btns">
                            <button
                                onClick={() =>
                                onApprove(item.id, props.proposalNumber)
                                }
                                disabled={item.approvedPayment}
                                className={`approve-btn ${
                                item.approvedPayment ? "disabled" : ""
                                }`}
                            >
                                {item.approvedPayment ? "approved" : "approve"}
                            </button>
                            {item.approvedPayment ? (
                                ""
                            ) : (
                                <button
                                className="approve-btn"
                                onClick={() => editPaymentChecker(item)}
                                >
                                Edit
                                </button>
                            )}{" "}
                            </div>
                        ) : (
                            <span
                            className="price delete-pay"
                            onClick={() => deletePayMethod(item.id)}
                            >
                            <img src={deleteButton} alt="delete pay option"></img>
                            </span>
                        )}
                        {item.txAmount}
                        </div>
                    </div>
                    );
                }
                )}
            </div>

            <div className="payable-wrapper">
                <div className="payable-heading">Total Premium Remaining</div>
                <div className="payable-amount">
                ₹ {indianCurrencyFormat(getRemainingPremium())}
                <br />
                </div>
            </div>
            </div>
        )}

        {(getUserDetails().user.role !== "CHECKER" || paymentChecker) && (
            <div className="payment_container row">
            <div className="form-halfs">
                <div className="column input-fields-wrapper">
                <label>Payment Method</label>
                <select
                    name="paymentMethod"
                    className="input-field"
                    value={payment.paymentMethod}
                    onChange={(e) =>
                    paymentChangeHandler(e.target.name, e.target.value)
                    }
                >
                    <option value="DEMAND_DRAFT">Demand Draft</option>
                    <option value="CHEQUE">Cheque</option>
                    {enableCashPayment && <option value="CASH">Cash</option>}
                    { channelName === "D2C" && enableNeftpayment && <option value="NEFT">NEFT</option>}
                </select>
                </div>
                <div className="input-fields-wrapper column">
                <label>Total Amount</label>
                <input
                    className="input-field"
                    type="number"
                    name="paymentAmount"
                    value={payment.paymentAmount}
                    onChange={(e) => {
                    if (
                        payment.paymentMethod === "CASH" &&
                        e.target.value < 200000
                    ) {
                        paymentChangeHandler(e.target.name, e.target.value);
                    } else if (payment.paymentMethod !== "CASH") {
                        paymentChangeHandler(e.target.name, e.target.value);
                    }
                    }}
                />
                </div>
            </div>

            <div className="form-halfs">
                {payment.paymentMethod === "DEMAND_DRAFT" && (
                <div className="input-fields-wrapper column">
                    <label>DD Number</label>
                    <input
                    className="input-field"
                    type="number"
                    name="checkOrDdNumber"
                    value={payment.checkOrDdNumber}
                    onChange={(e) => {
                        if (e.target.value.length < 7)
                        paymentChangeHandler(e.target.name, e.target.value);
                    }}
                    />
                </div>
                )}
                {payment.paymentMethod === "CHEQUE" && (
                <div className="input-fields-wrapper column">
                    <label>IFSC Code</label>
                    <input
                    className="input-field"
                    type="text"
                    name="ifscCode"
                    value={payment.ifscCode}
                    onChange={(e) =>
                        paymentChangeHandler(e.target.name, e.target.value)
                    }
                    />
                    <div className="error-text">{ifscError}</div>
                </div>
                )}
                {(payment.paymentMethod === "DEMAND_DRAFT" ||
                payment.paymentMethod === "CHEQUE") && (
                <div className="input-fields-wrapper column">
                    <label>Bank Name</label>
                    <input
                    className="input-field"
                    type="text"
                    name="bankName"
                    value={payment.bankName}
                    onChange={(e) =>
                        paymentChangeHandler(e.target.name, e.target.value)
                    }
                    />
                </div>
                )}
                {(payment.paymentMethod === 'NEFT')  && (
                    <>
                    <div className="input-fields-wrapper column">
                            <Input2
                            inputType="text"
                            placeholder=""
                            onChange={(e) => {
                                paymentChangeHandler(e.target.name, e.target.value);
                            }}
                            onKeyPress={(e) => {
                                if (
                                    e.which === 46
                                ) {
                                    e.preventDefault();
                                    return false;
                                }
                            }}
                            name="utrNumber"
                            value={payment.utrNumber}
                            label="UTR No."
                            editable={true}
                            isRequired={true}
                            noDecimal={true}
                            numberLength={25}
                            noSpecialChar={true}
                        />
                    </div>
                    <div className="input-fields-wrapper column">
                        <label>Transaction Date</label>
                        <input
                            className="input-field"
                            name="chequeOrDdDate"
                            value={payment.chequeOrDdDate}
                            onClick={calendarFunction}
                        />
                        { window.envType !== 'DEV' && <div className='time-wrapper d-sm-inline-flex'>
                            <div className="start-time-wrapper">
                                 <div className="start-time-container">
                                    <input
                                    className="input-time"
                                    maxLength={2}
                                    placeholder={"HH"}
                                    name="hour"
                                    value={time.hour}
                                    onChange={(e)=>{paymentChangeHandler(e.target.name, e.target.value)}}
                                    onBlur={(e)=>{checkZeroForTime(e.target.value, e.target.name)}}
                                    />
                                    <span className="collon-space">:</span> 
                                    <input
                                    className="input-time"
                                    placeholder={"MM"}
                                    maxLength={2}
                                    max={59}
                                    min={0}
                                    name="min"
                                    value={time.min}
                                    onChange={(e)=>{paymentChangeHandler(e.target.name, e.target.value)}}
                                    onBlur={(e)=>{checkZeroForTime(e.target.value, e.target.name)}}
                                    />
                                    <span className="collon-space">:</span>
                                    <input 
                                    className="input-time"
                                    placeholder={"SS"}
                                    maxLength={2}
                                    max={59}
                                    min={0}
                                    name="sec"
                                    value={time.sec}
                                    onChange={(e)=>{paymentChangeHandler(e.target.name, e.target.value)}}
                                    onBlur={(e)=>{checkZeroForTime(e.target.value, e.target.name)}}
                                    />
                                </div>
                            </div>
                        </div>}
                    </div>
                    </>
                )}
            </div>

            <div className="form-halfs">
                {payment.paymentMethod === "DEMAND_DRAFT" && (
                <>
                    <div className="input-fields-wrapper column">
                    <label>DD Date</label>
                    <input
                        className="input-field"
                        name="chequeOrDdDate"
                        value={payment.chequeOrDdDate}
                        onClick={calendarFunction}
                    />
                    </div>
                    <div className="input-fields-wrapper column">
                    <label>DD Expiry Date</label>
                    <input
                        className="input-field"
                        name="expiryDate"
                        disabled
                        value={payment.expiryDate}
                    />
                    </div>
                </>
                )}
            </div>

            <div className="form-halfs">
                {payment.paymentMethod === "CHEQUE" && (
                <>
                    <div className="input-fields-wrapper column">
                    <label>Cheque Date</label>
                    <input
                        className="input-field"
                        name="chequeOrDdDate"
                        value={payment.chequeOrDdDate}
                        // onChange={(e) => paymentChangeHandler(e.target.name, e.target.value)}
                        onClick={calendarFunction}
                    />
                    </div>
                    <div className="input-fields-wrapper column">
                    <label>Expiry Date</label>
                    <input
                        className="input-field"
                        name="expiryDate"
                        disabled
                        value={payment.expiryDate}
                    />
                    </div>
                </>
                )}
            </div>

            <div className="form-halfs">
                {payment.paymentMethod === "CHEQUE" && (
                <>
                    <div className="input-fields-wrapper column">
                    <label>Cheque Number</label>
                    <input
                        type="number"
                        className="input-field"
                        name="checkOrDdNumber"
                        value={payment.checkOrDdNumber}
                        onChange={(e) => {
                        if (e.target.value.length < 7)
                            paymentChangeHandler(e.target.name, e.target.value);
                        }}
                    />
                    </div>
                    <div className="input-fields-wrapper column">
                    <label>NRE Acc. (Optional)</label>
                    <input
                        className="input-field"
                        name="nreAccount"
                        value={payment.nreAccount}
                        disabled
                        onChange={paymentChangeHandler}
                    />
                    </div>
                </>
                )}
            </div>
            <div className="branch">
                <div className="branch-head">Select Branch</div>
                <div className="branch-list">
                <Select
                    name="branchCd"
                    options={branchLocation}
                    value={branch}
                    onChange={(e) => locationChange(e)}
                    getOptionLabel={(branchLocation) => branchLocation.name}
                    getOptionValue={(branchLocation) => branchLocation.key}
                    isClearable={true}
                />
                </div>
                {/*  <select>
                                                {branchLocation.map(item => <option value={item.key} key={item.key}>{item.name}</option>)}
                                            </select>*/}
            </div>
            <button className="btn-pay" disabled={payEnable} onClick={payNow}>
                Pay Now
            </button>
            {showdate && (
                <MobilePopUp
                hideCloseBtn={true}
                removeHeader={true}
                cssClass="daterange-mobilepopup"
                >
                <Calendar
                    maxDate={new Date()}
                    minDate={pastDate(new Date(), 70)}
                    onCancel={() => {
                    openDate(false);
                    }}
                    onApply={(sd) => {
                    paymentChangeHandler("chequeOrDdDate", sd);
                    openDate(false);
                    }}
                />
                </MobilePopUp>
            )}
            </div>
        )}
        </>
    );
};

export default PaymentOptions;
